import * as React from "react";
import { Text, View, Image, StyleSheet, Dimensions } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import GlobalStyles from "../components/GlobalStyles";
import FooterBarWide from "../components/footerBarWide";
import MenuBar from "../components/headers/MenuBar";
import StatusBar from "../components/headers/StatusBar";
import InviteWebHeader from "../components/InviteWebHeader";

import { useSelector } from "react-redux";

const sparkle = require("../assets/res/sparkle_Alpha_LOOP.gif");

export default function InvestScreen() {
  var investedAmount =
    useSelector((state) => state.user.userData.balance.amountInvested) || 0;
  var donatedAmount =
    useSelector((state) => state.user.userData.balance.amountDonated) || 0;
  var withdrawnAmount =
    useSelector((state) => state.user.userAmountWithdrawn) || 0;
  var withdrawnAmount = Number.parseFloat(withdrawnAmount);
  var donatedAmount = Number.parseFloat(donatedAmount);
  var investedAmount = Number.parseFloat(investedAmount) - withdrawnAmount;
  const win = Dimensions.get("window");

  return (
    <View style={GlobalStyles.containerMB}>
      <ScrollView style={styles.scrollArea}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="4" />
            <View style={GlobalStyles.headerContainerKLYellow}>
              <View style={[GlobalStyles.headerTextYellow]}>
                <Text style={GlobalStyles.headingStyle}>Invest</Text>
                <Text style={GlobalStyles.subheaderStyleWeb}>
                  Your Aura earnings summary.
                </Text>
                <Text style={GlobalStyles.subheaderStyleWeb}>
                  Investment options coming soon!
                </Text>
              </View>
              {/* <InviteWebHeader /> */}
            </View>
          </View>
        ) : (
          <View style={GlobalStyles.fullHeaderBarW}>
            <StatusBar data="B" />
            <View style={GlobalStyles.headerContainerKL}>
              <View style={[GlobalStyles.headerText]}>
                <Text style={GlobalStyles.headingStyle}>Invest</Text>
                <Text style={GlobalStyles.subheaderStyle}>
                  Your Aura earnings summary.
                </Text>
                <Text style={GlobalStyles.subheaderStyle}>
                  Investment options coming soon!
                </Text>
              </View>
            </View>
          </View>
        )}
        {/* <View style={win.width < 768 ? styles.bodyContainerInvest : GlobalStyles.webBodyContainer }> */}
        <View style={GlobalStyles.adjustableBodyContainer}>
          <View style={styles.SavingsBoxTop}>
            <View style={styles.numberBox}>
              <Image style={styles.sparkle} source={sparkle} />
              <Text style={styles.AmountBig}>
                $
                {investedAmount
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
              </Text>
              <Text style={styles.subText}>YOUR BALANCE</Text>
            </View>
              <View style={styles.greyLine}></View>
          </View>

          <View style={styles.SavingsBox}>
            <View style={styles.numberBox}>
              <Text style={styles.Amount}>
                $
                {donatedAmount
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
              </Text>
              <Text style={styles.subTextDonated}>DONATED</Text>
            </View>
              <View style={styles.greyLine}></View>
          </View>
          <View style={styles.SavingsBox}>
            {withdrawnAmount != 0 ? (
              <View style={styles.numberBox}>
                <Text style={styles.Amount}>
                  $
                  {withdrawnAmount
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                </Text>
                <Text style={styles.subTextDonated}>WITHDRAWN</Text>
              </View>
            ) : null}
          </View>
        </View>
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  greyLine: {
    width: "100%",
    maxWidth: 500,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderColor: "#dddddd",
    //paddingTop: 40,
    //paddingBottom: 20,
    paddingLeft: 0,
    paddingRight: 0,
    //marginBottom: 15,
    marginTop: 15,
    alignSelf: "center",
  },
  bodyContainerInvest: {
    flex: 1,
    paddingTop: 50,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
  },
  scrollArea: {
    flex: 1,
  },
  centerHeaderContent: {
    //flex: 1,
    justifyContent: "center",
    //paddingRight: 100,
    paddingTop: 65,
  },
  centerContent: {
    flex: 1,
    justifyContent: "center",
  },
  SubmitButtonStyle: {
    marginTop: 10,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 50,
    marginRight: 50,
    backgroundColor: "#B4C55B",
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "#fff",
  },
  TextStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },
  headerContainer: {
    height: 120,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 80,
  },
  headerText: {
    position: "absolute",
    top: 0,
    left: 50,
    width: "100%",
  },
  infoBox: {
    backgroundColor: "#ffffff",
    borderRadius: 30,
    marginBottom: 0,
  },
  splitBox: {
    marginBottom: 20,
    paddingLeft: 20,
    paddingRight: 40,
  },
  cardImage: {
    width: "100%",
    height: 275,
    resizeMode: "contain",
  },
  infoImage: {
    width: "100%",
    height: 275,
    resizeMode: "contain",
  },
  optionPromo: {
    alignContent: "center",
    top: 0,
    left: 20,
    height: 42,
    width: 42,
    borderRadius: 25,
    backgroundColor: "#ffffff",
    alignSelf: "center",
  },
  optionPromoText: {
    alignSelf: "center",
    paddingTop: 10,
    color: "#2B587A",
    fontFamily: "montserrat-bold",
    fontSize: 18,
  },
  optionText: {
    paddingTop: 3,
    alignSelf: "flex-start",
    color: "#ffffff",
    fontFamily: "montserrat-bold",
    fontSize: 18,
  },
  closeBottom: {
    color: "red",
  },
  headerText: {
    position: "absolute",
    top: 0,
    left: 50,
    width: "100%",
  },
  filterBox: {
    flex: 1,
    flexDirection: "row",
    paddingTop: 8,
    alignItems: "flex-end",
  },
  filterBoxA: {
    flex: 10,
  },
  filterBoxB: {
    flex: 2,
  },
  filterText: {
    fontFamily: "montserrat-regular",
    fontSize: 8,
    textAlign: "right",
    marginBottom: 5,
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "left",
    marginBottom: 5,
  },
  headerSavingsBox: {
    //flex: 1,
    flexDirection: "row",
    paddingTop: 10,
    alignItems: "flex-end",
  },
  headerSavingsBoxYellow: {
    //flex: 1,
    flexDirection: "row",
    //paddingTop: 10,
    paddingLeft: 30,
    marginTop: -10,
    alignItems: "flex-end",
  },
  SavingsBox: {
    //flex: 1,
    alignItems: "center",
    //paddingTop: 20,
  },
  SavingsBoxTop: {
    //flex: 1,
    alignItems: "center",
    paddingTop: 20,
  },
  numberBox: {
    flex: 1,
    alignItems: "flex-end",
    //width: "100%",
    //alignItems: "center",
  },

  DonationBox: {
    flex: 1,
    alignItems: "flex-start",
  },
  RightSpaceBox: {
    flex: 2,
  },
  Amount: {
    fontFamily: "montserrat-bold",
    fontSize: 26,
    textAlign: "right",
    marginBottom: 5,
    color: "#FFFFFF",
    paddingTop: 30,
  },
  AmountBig: {
    fontFamily: "montserrat-bold",
    fontSize: 50,
    textAlign: "right",
    marginBottom: 5,
    color: "#FFFFFF",
  },
  subText: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "center",
    color: "#FFFFFF",
    width: "100%",
    alignSelf: "center",
  },
  subTextDonated: {
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "center",
    color: "#FFFFFF",
    width: "100%",
    alignSelf: "center",
  },
  bodyContainer: {
    paddingTop: 0,
    flex: 1,
    zIndex: 2,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  sparkle: {
    position: "absolute",
    top: -20,
    right: -30,
    width: 40,
    height: 40,
  },
  rightBox: {
    flex: 1,
    alignItems: "flex-end",
  },
});
